import { format } from "date-fns";
import { ru } from "date-fns/locale";

import { daysMS, months } from "./constant";

// -------------------------------------------------------------
const getDateByDayBack = n => new Date(Date.now() - n * 24 * 3600 * 1000);
// -------------------------------------------------------------
const getFrontDate = (userDate = "", viewOption = "dd.MM.yyyy") => {
  if (userDate === "" || userDate == null) return "";
  try {
    const date = typeof userDate === "object" ? userDate : new Date(userDate);
    if (isNaN(date.getTime())) return "";
    return format(date, viewOption, { locale: ru });
  } catch (err) {
    return "";
  }
};
// -------------------------------------------------------------
const getServerDate = (userDate = "") => {
  if (userDate === "" || userDate == null) return undefined;
  try {
    const date = typeof userDate === "object" ? userDate : new Date(userDate);
    if (isNaN(date.getTime())) return undefined;
    return format(date, "yyyy-MM-dd");
  } catch (err) {
    return undefined;
  }
};
//
export const isDateCorrect = date => {
  try {
    new Date(date);
    return true;
  } catch (e) {
    return false;
  }
};
// Для внутренней аналитика нужно передавать точное время, это костыль для бека
export const getIADateFrom = date => getServerDate(date) && getServerDate(date) + "T00:00:00+03:00";
export const getIADateTo = date =>
  getServerDate(date) && getServerDate(date) + "T23:59:59.999+03:00";
//
const getDateFromWithTime = date => getServerDate(date) && getServerDate(date) + "T00:00:00+03:00";
const getDateToWithTime = date =>
  getServerDate(date) && getServerDate(date) + "T23:59:59.999+03:00";
//
// -------------------------------------------------------------------------
function formatToISOWithTimezone(date) {
  const tzOffset = 3 * 60; // Сдвиг +03:00 в минутах
  const tzHours = Math.floor(tzOffset / 60)
    .toString()
    .padStart(2, "0");
  const tzMinutes = (tzOffset % 60).toString().padStart(2, "0");
  const isoString = new Date(date).toISOString(); // Формат в UTC
  const formatted = isoString.replace("Z", `+${tzHours}:${tzMinutes}`);
  return formatted;
}
// -------------------------------------------------------------------------
function getPreviousPeriod(period) {
  const [startDate, endDate] = period.map(i => new Date(i));
  const periodLength = Math.floor((endDate - startDate) / daysMS) + 1;
  return [
    new Date(startDate - periodLength * daysMS),
    new Date(endDate - periodLength * daysMS),
  ].map(i => formatToISOWithTimezone(i));
}
// -------------------------------------------------------------------------
const getMonthDate = (date = "2024-11") => {
  const dateObj = new Date(date);
  const year = dateObj.getFullYear();
  const month = dateObj.getMonth() + 1;
  return `${months.find(i => i.id == month)?.title || month} ${year}`;
};
//
function getPreviousFullMonthDates(n = 1, startDate = new Date()) {
  // const now = new Date(); // текущая дата
  const now = startDate;
  const year = now.getFullYear();
  let month = now.getMonth(); // текущий месяц (0-11)
  let prevYear;
  // Получаем предыдущий месяц
  if (month === 0) {
    month = 11; // декабрь
    prevYear = year - 1;
  } else {
    month -= n;
    prevYear = year;
  }
  //
  const firstDay = new Date(prevYear, month, 1);
  const lastDay = new Date(prevYear, month + 1, 0);
  //
  return [firstDay, lastDay];
}
//
function getPreviousFullWeekDates(n = 1, startDate = new Date()) {
  // const now = new Date();
  const now = startDate;
  const dayOfWeek = now.getDay();
  // Чтобы определить начало текущей недели (понедельник), вычислим разницу от сегодня:
  let daysToThisMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // сколько дней назад был понедельник
  // const thisMonday = new Date();
  const thisMonday = startDate;
  thisMonday.setDate(now.getDate() - daysToThisMonday);
  // Предыдущая полная неделя — это предшествующий понедельник-воскресенье
  const prevWeekMonday = new Date(thisMonday);
  prevWeekMonday.setDate(thisMonday.getDate() - 7 * n); // от текущего понедельника минус 7 дней — понедельник прошлой недели
  const prevWeekSunday = new Date(prevWeekMonday);
  prevWeekSunday.setDate(prevWeekMonday.getDate() + 6); // воскресенье той же недели
  //
  return [prevWeekMonday, prevWeekSunday];
}

export {
  getFrontDate,
  getServerDate,
  getDateByDayBack,
  getPreviousPeriod,
  getMonthDate,
  getDateFromWithTime,
  getDateToWithTime,
  getPreviousFullMonthDates,
  getPreviousFullWeekDates,
};
